<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
/* .el-form-item__content {
  width: 350px !important;
} */
.column_radio .el-radio {
  display: block !important;
  margin: 5px 0 !important;
  text-align: left;
}
.el-upload-list__item,
.el-upload {
  font-size: 28px;
  color: #8c939d;
  width: 78px !important;
  height: 78px !important;
  line-height: 78px !important;
  text-align: center;
}
.el-upload-list__item-status-label {
  display: none !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}
.avatar {
  width: 78px;
  height: 78px;
  display: block;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
